(function() {
    angular
        .module("noticesModule", [
            "ui.router"
        ])
})()
